module.exports = __webpack_public_path__ + "static/media/percentage_grey.7b6f0cb2.svg";